import { graphql } from "relay-runtime"

export const deDeleteProgressNoteMutation = graphql`
  mutation deDeleteProgressNoteMutation($input: De_deleteProgressNoteInput!, $connections: [ID!]!) {
    deleteProgressNote: de_deleteProgressNote(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      progressNote: de_ProgressNote {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
